import { StatusCircle } from '@/app/components'
import { CardActionButton, CardActions, Modal, Text } from '@/components'

type Props = {
  open: boolean
  onClose: () => void
}

export default function DeviceOptedOutModal({ open, onClose }: Props) {
  return (
    <Modal
      id="vehicle-dr-event-opt-in-confirmation-modal"
      open={open}
      onClose={onClose}
    >
      <div className="flex flex-col items-center p-4 text-center">
        <StatusCircle status="succeeded" />
        <Text variant="h3" className="mt-4 font-bold">
          You've successfully opted out of this event.
        </Text>

        <div className="w-full mt-6">
          <CardActions>
            <CardActionButton
              id="vehicle-dr-event-opt-out-close-button"
              type="primary"
              onClick={onClose}
            >
              Close
            </CardActionButton>
          </CardActions>
        </div>
      </div>
    </Modal>
  )
}
